var map = {
	"./view-bird-animation-1.png": "6640",
	"./view-cloud-animation-1.png": "9758",
	"./view-rain-animation-1.png": "8039",
	"./view-star-animation-1.png": "13d4",
	"./view-tree-animation-1.png": "38c9"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "24a1";